/** @format */

import styled from "styled-components";
import { colors } from "../../../css/variables/colors";
import { mixins } from "../../../css/variables/mixins";
import { fonts } from "../../../css/variables/fonts";
import EntryGuideWhiteIcon from "../../../images/EntryGuideWhite.svg";

type entryGuideWrapperType = { path: string };
const EntryGuideWrapper = styled.button<entryGuideWrapperType>`
  z-index: 990;
  box-sizing: border-box;
  position: fixed;
  bottom: 60px;
  right: 20px;
  height: 48px;
  background-color: ${colors.themeColor("background_button_primary")};
  border: 1px solid ${colors.themeColor("border_box")};
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 240px;
  padding: 12px 16px;
  gap: 8px;
  cursor: pointer;
  ${mixins.screenUnder()} {
    bottom: 16px;
    right: 8px;
    ${(props) => (props.path.includes("entry/") || props.path.includes("redirect/") ? "bottom: 68px;" : "")}
  }
`;

const EntryGuideText = styled.p`
  font-size: ${fonts.fontSizeRem("s")};
  color: ${colors.themeColor("text_button_primary")};
  margin-bottom: 0px;
`;

const EntryGuide = ({ path, zAccount }: { path: string; zAccount: string }) => {
  // 申し込みガイドの遷移
  let entryGuideUrl = "https://www.cardservice.co.jp/partner/ocnk02/guide/";
  if (zAccount === "bcart") {
    entryGuideUrl = "https://www.cardservice.co.jp/partner/bcart/guide/";
  } else if (zAccount === "emochi") {
    entryGuideUrl = "https://www.cardservice.co.jp/partner/emochi/guide/";
  }
  const navigateEntryGuide = () => {
    window.open(entryGuideUrl, "_blank", "noopener=yes");
  };
  return (
    <EntryGuideWrapper onClick={navigateEntryGuide} path={path}>
      <img src={EntryGuideWhiteIcon} alt="EntryGuideIcon" />
      <EntryGuideText>申し込みガイド</EntryGuideText>
    </EntryGuideWrapper>
  );
};

export default EntryGuide;
